import {
  InviteColleagueFormShape,
  SendSupportUserRequestInput,
} from './InviteColleagueModal.constants';

export function mapFormDataToInput(
  formValues: InviteColleagueFormShape
): SendSupportUserRequestInput {
  if (!formValues.accessLevel) {
    throw new Error('Access level is required.');
  }

  return {
    firstName: formValues.firstName,
    lastName: formValues.lastName,
    email: formValues.email,
    accessLevel: formValues.accessLevel,
  };
}
